import { render, staticRenderFns } from "./aiscript-list.vue?vue&type=template&id=f251d37a&"
import script from "./aiscript-list.vue?vue&type=script&lang=js&"
export * from "./aiscript-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "aiscript-list.vue"
export default component.exports